export const ENDPOINTS = {
    credentialValidation:"/inds/get-credential-validation", 
    associateHoneywellID:"inds/associate-honeywellid-customer",
    generateToken:"/auth/generate-client-credential-token",
    validateRole:"inds/validate-user-association-role",
    customerBasicInfo:"/inds/customer-basic-info",
    customerUsersSearch:"/users/sso/details"
};
